export const generalProductsForHome=[
    {
        "no": 22,
        "id": "c17",
        "productname": "Apple ear buds",
        "productprice": 20000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c17-earbuds-img.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"Apple beats by dre ear buds"
    },
    {
        "no": 24,
        "id": "c18",
        "productname": "Air pod pro",
        "productprice": 11000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c18-earbuds-img.jpg",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"wireless bluetooth air pods with noise..."
    },
    {
        "no": 29,
        "id": "c19",
        "productname": "Samsung buds pro",
        "productprice": 72000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c19-earbuds-img.jpeg",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"Samsung galaxy buds pro phantom silver"
    },
    {
        "no": 30,
        "id": "c20",
        "productname": " earphones",
        "productprice": 3900,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c20-earbuds-img.jpeg",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"Bluetooth 5.0 earphones LED display touch control headset"
    },
    {
        "no": 35,
        "id": "c21",
        "productname": "gas cooker",
        "productprice": 59000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c21-gascooker-img.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"gas cooker with space for six gas cookers,one..."
    },
    {
        "no": 97,
        "id": "c22",
        "productname": "Center Carpet",
        "productprice": 10000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c22-carpet-img.jpeg",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"Flannel Center Rug/Carpet - 120*160cm"
    },
    {
        "no": 96,
        "id": "c23",
        "productname": "Mobile Wardrobe",
        "productprice": 27900,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c23-wardrope-img.jpeg",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"Steel Mobile Wardrobe With 3 Real Standard Doors"
    },
    {
        "no": 41,
        "id": "c24",
        "productname": "Vitafoam mattress",
        "productprice": 112000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c24-mattress-img.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"Vita foam semi orthopedic mattress"
    },
    {
        "no": 31,
        "id": "c25",
        "productname": "Gucci bag",
        "productprice": 651000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c25-bag-img.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"GG Marmont Small Top Handle Bag"
    },
    {
        "no": 32,
        "id": "c26",
        "productname": "Louis Vuitton Bag",
        "productprice": 483000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c26-bag-img.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"Louis Vuitton Bandoulier Speedy Bag"
    },
    {
        "no": 36,
        "id": "c27",
        "productname": "Hermes hand bag",
        "productprice": 9840000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c27-bag-img.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"Caviar Quilted Small Double Flap Grey..."
    },
    {
        "no": 34,
        "id": "c28",
        "productname": "Black dior bag",
        "productprice": 1230000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c28-bag-img.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"Dior Lady Supple Limited Detachable Strap Black ..."
    },
    {
        "no": 37,
        "id": "c29",
        "productname": "louis vuitton set",
        "productprice": 840000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c29-bag-img.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"four piece louis vuitton set shoe,bag,purse"
    },
    {
        "no": 38,
        "id": "c30",
        "productname": "Louis vuitton bag",
        "productprice": 440000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c30-bag-img.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"Three piece louis vuitton haumea hand bag"
    },
    {
        "no": 39,
        "id": "c31",
        "productname": "Channel set",
        "productprice": 790000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c31-bag-img.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"four pink channel hand bags"
    },
    {
        "no": 40,
        "id": "c32",
        "productname": "Coco chanel set",
        "productprice": 860000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c32-bag-img.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoesize": null,
        "productinfopreview":"coco chanel five peice black hand bag"
    },
    {
        "no": 25,
        "id": "c33",
        "productname": "Black dior shirt",
        "productprice": 19000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c33-shirt-img.png.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoe":true,
        "shoesize": 31,
        "productinfopreview":"black dior shirt"
    },
    {
        "no": 26,
        "id": "c34",
        "productname": "Black designer shirt",
        "productprice": 11000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c34-shirt-img.png.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoe":true,
        "shoesize": 31,
        "productinfopreview":"black designer shirt"
    },
    {
        "no": 27,
        "id": "c35",
        "productname": "Black dior shirt",
        "productprice": 16000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c35-shirt-img.png.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoe":true,
        "shoesize": 31,
        "productinfopreview":"black dior shirt"
    },
    {
        "no": 28,
        "id": "c36",
        "productname": "Blue gucci sweater",
        "productprice": 32000,
        "quantity":1,
        "productinfo": null,
        "productimage1": "/skydome images/c36-shirt-img.png.png",
        "productimage2": null,
        "processortype": null,
        "processorname": null,
        "brand": null,
        "batteryinfo": null,
        "ram": null,
        "rom": null,
        "windowversion": null,
        "color": null,
        "touchscreen": null,
        "netweight": null,
        "inch": null,
        "gaminggraphics": null,
        "network": null,
        "frontcamera": null,
        "rearcamera": null,
        "shoe":true,
        "shoesize": 31,
        "productinfopreview":"blue gucci sweater"
    }
]